import classNames from 'classnames';
import ReactDOM from 'react-dom';
import styles from './style.module.scss';

interface ToastProps {
  content: any;
  type: 'success' | 'error' | 'info';
  className?: string;
  textCenter?: boolean;
}

const ErrorIcon = () => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1785"
      width="16"
      height="16"
    >
      <defs>
        <style type="text/css" />
      </defs>
      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#F56C6C" p-id="1786" />
      <path
        d="M760.035556 756.906667a33.848889 33.848889 0 0 1-24.462223 10.24 34.702222 34.702222 0 0 1-24.462222-10.24l-195.982222-195.982223-195.697778 195.982223a34.986667 34.986667 0 0 1-48.924444 0 34.417778 34.417778 0 0 1 0-48.924445L466.204444 512l-195.697777-195.982222a34.702222 34.702222 0 0 1 48.924444-48.924445l195.697778 195.982223L711.111111 267.093333a34.702222 34.702222 0 0 1 59.164445 24.746667 33.564444 33.564444 0 0 1-10.24 24.177778L564.337778 512l195.697778 197.12a33.848889 33.848889 0 0 1 10.24 24.462222 34.702222 34.702222 0 0 1-10.24 24.462222z m0 0"
        fill=""
        p-id="1787"
      />
    </svg>
  );
};

const SuccessIcon = () => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
    >
      <path
        d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6zM296.8576 475.0336a51.2 51.2 0 1 0-70.7584 73.9328l194.3552 185.856a51.2 51.2 0 0 0 70.9632-0.2048L831.488 406.1184a51.2 51.2 0 1 0-71.0656-73.728L455.68 626.7904 296.8576 475.136z"
        fill="#00ac5b"
      />
    </svg>
  );
};

const IconMap = {
  info: null,
  success: <SuccessIcon />,
  error: <ErrorIcon />,
};

const ToastComponents: React.FC<ToastProps> = ({ content, type, className, textCenter }) => {
  const icon = IconMap[type];
  return (
    <div className={classNames(styles.toast, className)} style={{ textAlign: textCenter ? 'center' : undefined }}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span>{content}</span>
    </div>
  );
};

const renderToast = (props: ToastProps) => {
  const root = document.createElement('div');
  ReactDOM.render(<ToastComponents {...props} />, root);
  document.body.append(root);
  setTimeout(() => {
    ReactDOM.unmountComponentAtNode(root);
    document.body.removeChild(root);
  }, 3e3);
};

const Toast = {
  info(content: ToastProps['content'], props: Partial<ToastProps> = {}) {
    return renderToast({ content, type: 'info', ...props });
  },
  success(content: string) {
    return renderToast({ content, type: 'success' });
  },
  error(content: string) {
    return renderToast({ content, type: 'error' });
  },
};

export default Toast;
